/**
 * Generate text to promote buying more bottles and joining as a PC if they aren't already.
 * @param bottleCount The number of bottles in the user's cart
 * @param isPC Whether the user is a PC (or has it in their cart)
 * @param discounts A tuple of 6/12 pack discount percentages. Defaults to 10%/20% but can be overridden
 *                  for e.g. promotional sales.
 * @param promoText Optional promo text to append to the string
 */
export const case4CauseToastGetSalesText = (
  bottleCount: number,
  isPC: boolean = false,
  discounts = [5, 10, 20],
  promoText = '',
  pcPotentialSavings: number | null,
  c4cCartTotal: number,
): { bronzeText: string; blackText: string } => {
  let count = bottleCount;
  if (count === 0) {
    if (c4cCartTotal < 12) {
      return {
        bronzeText: `Save up to 20% `,
        blackText: `and get 1/2 off shipping!`,
      };
    }
    count = c4cCartTotal % 12;
  }
  if (count < 4) {
    if (
      c4cCartTotal >= 12 &&
      pcPotentialSavings &&
      pcPotentialSavings > 0 &&
      pcPotentialSavings.toFixed
    ) {
      return {
        bronzeText: isPC
          ? `You saved $${pcPotentialSavings.toFixed(2)}! `
          : `You could save $${pcPotentialSavings.toFixed(2)}! `,
        blackText: `Add ${4 - count} more to save another ${
          discounts[0]
        }%${promoText}!`,
      };
    }
    return {
      bronzeText: `Add ${4 - count} more `,
      blackText: `to save ${
        discounts[0]
      }%${promoText} and get 1/2 off shipping!`,
    };
  }

  if (
    pcPotentialSavings &&
    pcPotentialSavings > 0 &&
    pcPotentialSavings.toFixed
  ) {
    if (count < 6) {
      return {
        bronzeText: isPC
          ? `You saved $${pcPotentialSavings.toFixed(2)}! `
          : `You could save $${pcPotentialSavings.toFixed(2)}! `,
        blackText: `Add ${6 - count} more to save ${
          c4cCartTotal < 12 ? '' : 'another'
        } ${discounts[1]}%${promoText}!`,
      };
    }
    if (count < 12) {
      return {
        bronzeText: isPC
          ? `You saved $${pcPotentialSavings.toFixed(2)}! `
          : `You could save $${pcPotentialSavings.toFixed(2)}! `,
        blackText: `Add ${6 - (count % 6)} more to save ${
          c4cCartTotal < 12 ? '' : 'another'
        } ${discounts[2]}%${promoText}!`,
      };
    }
  }
  return {
    bronzeText: '',
    blackText: '',
  };
};
